module.exports = __webpack_public_path__ + "img/CRT_Weapon-Sword-04.dfc469b9.png";